(ns bec-cljs-common.re-frame.subs
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.utils.touch :refer [touch-variables]]
            [bec-cljs-common.utils.css :as css]
            [bec-cljs-common.utils.visibility :as visibility]
            [bec-cljs-common.components.accordion :as accordion]
            [bec-cljs-common.components.input :as input]
            [bec-cljs-common.components.modal :as modal]
            [bec-cljs-common.components.picker :as picker]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.re-frame :as bec-rf]
            [bec-cljs-common.networking :as bec-net]))

(rf/reg-sub ::bec-net/initialized?
  (fn [db _]
    (::bec-net/initialized? db)))

(rf/reg-sub ::bec-net/sse-connected?
  (fn [db _]
    (::bec-net/sse-connected? db)))

(rf/reg-sub :get-in
  (fn [db [_ path]]
    (get-in db path)))

(rf/reg-sub :touch
  (fn [_ [_ k]]
    (if k
      (get @touch-variables k)
      @touch-variables)))

(defonce window-resize
  (let [a (r/atom {:width  (.-innerWidth  js/window)
                   :height (.-innerHeight js/window)})]
    (.addEventListener js/window "resize"
                       (fn []
                         (reset! a {:width  (.-innerWidth  js/window)
                                    :height (.-innerHeight js/window)})))
    a))

(rf/reg-sub :window-size
  (fn [_ [_ dimension]]
    (if dimension
      (get @window-resize dimension)
      @window-resize)))

(defonce window-scroll
  (let [a (r/atom {:scroll-y (.-scrollY  js/window)
                   :scroll-x (.-scrollX js/window)})]
    (.addEventListener js/window "scroll"
                       (fn []
                         (reset! a {:scroll-y (.-scrollY js/window)
                                    :scroll-x (.-scrollX js/window)
                                    :previous-scroll-y (:scroll-y @a)
                                    :previous-scroll-x (:scroll-x @a)})))
    a))

(rf/reg-sub :window-scroll
  (fn [_ [_ scroll-key]]
    (if scroll-key
      (get @window-scroll scroll-key)
      @window-scroll)))


(defonce CSS-supports
  {:scroll-margin-top (css/supports "scroll-margin-top:" "var(--scroll-margin-top)")})

(rf/reg-sub :CSS-supports
  (fn [_ [_ CSS-property]]
    (if CSS-property
      (get CSS-supports CSS-property)
      CSS-supports)))

(rf/reg-sub :theme
  (fn [_ [_ theme-key]]
    (case theme-key
      (:system :system-theme)
      @css/system-theme
      (:user-selected :user-selected-theme)
      @css/user-selected-theme
      (css/theme))))

(rf/reg-sub :display-mode
  (fn [_ [_ _]]
    @css/display-mode))

(rf/reg-sub :is-animating?
  (fn [_ [_ id]]
    (if id
      (get @css/animation-variables id)
      (not (empty? @css/animation-variables)))))

(rf/reg-sub :app-hidden?
  (fn [_ [_ _]]
    @visibility/hidden?))

(rf/reg-sub :picker
  (fn [_ [_ id]]
    (if id
      (get @picker/variables id)
      @picker/variables)))

(rf/reg-sub :modal
  (fn [_ [_ id]]
    (if id
      (get @modal/variables id)
      @modal/variables)))

(rf/reg-sub :accordion
  (fn [_ [_ id]]
    (if id
      (get @accordion/variables id)
      @accordion/variables)))

(rf/reg-sub :input-radio
  (fn [_ [_ id]]
    (if id
      (get (:radio @input/variables) id)
      (:radio @input/variables))))

(rf/reg-sub :input-checkbox
  (fn [_ [_ id]]
    (if id
      (get (:checkbox @input/variables) id)
      (:checkbox @input/variables))))

(rf/reg-sub :keypad
  (fn [db path]
    (get-in db path)))

(rf/reg-sub :config
  (fn [db _]
    (:config db)))

(rf/reg-sub
  :machine-id
  :<- [:config]
  (fn [config]
    (:machine-id config)))

(rf/reg-sub
  :machine-uuid
  :<- [:config]
  (fn [config]
    (:machine-uuid config)))

(rf/reg-sub :model
  :<- [:config]
  (fn [config] (:model config)))

(rf/reg-sub :config-booking
  :<- [:config]
  (fn [config]
    (:booking config)))

(rf/reg-sub :config-venue
  :<- [:config-booking]
  (fn [booking-config]
    (:venue booking-config)))

(rf/reg-sub :time-zone
  (fn [db _]
    (:time-zone (:config db))))

(def session-db-path [:bec-clj-common :session])

(rf/reg-sub :session
  (fn [db _]
    (get-in db session-db-path nil)))

(rf/reg-sub :remaining-seconds
  :<- [:session]
  (fn [session _]
    (:remaining-seconds session)))

(rf/reg-sub :remaining-minutes
  :<- [:remaining-seconds]
  (fn [remaining-seconds  _]
    (long (/ remaining-seconds 60))))

(rf/reg-sub :session-state
  :<- [:session]
  (fn [session _] 
    (:state session)))

(rf/reg-sub :session-active?
  :<- [:session-state]
  (fn [session-state _]
    (= :active session-state)))


(rf/reg-sub :players-allowed
  :<- [:session]
  :<- [:machine-uuid]
  (fn [[session machine-uuid] _]
    (let [bookable-info (first (filter #(= (:identifier %) machine-uuid) (:bookables (:booking session))))]
      (or (:max-capacity bookable-info) (:players-allowed session)))))

(def players-db-path [:bec-clj-common :players])

(defn get-players [db]
  #_(->> (vals (-> db :bec-clj-common :teams))              ;; Maybe for the future
    (map :players)
    (reduce merge))
  (get-in db players-db-path nil))

(rf/reg-sub :players
  (fn [db _]
    (get-players db)))

(rf/reg-sub :lookup
  (fn [db]
    (-> db :config :clients)))

(rf/reg-sub :colors
  :<- [:lookup]
  (fn [lookup _]
    (:colors lookup)))

(rf/reg-sub
  :default-teams
  :<- [:lookup]
  (fn [lookup _]
    (:default-teams lookup)))

(rf/reg-sub
  :default-teams-sorted
  :<- [:default-teams]
  (fn [default-teams _]
    (into (sorted-map-by (fn [key1 key2]
                           (compare
                             [(:index (get default-teams key1)) key1]
                             [(:index (get default-teams key2)) key2])))
      default-teams)))

(rf/reg-sub :general-colors
  (fn [db _]
    (:general-colors db)))

(rf/reg-sub :color-val
  :<- [:colors]
  :<- [:default-teams]
  (fn [[colors default-teams] [_ color-key]]
    (let [color-key (if (keyword? color-key)
                      color-key
                      (keyword color-key))]
      (get-in colors [(:color (get default-teams color-key)) :color]))))

(rf/reg-sub
  :rgb-color
  :<- [:colors]
  :<- [:default-teams]
  (fn [[colors default-teams] [_ color-key alpha]]
    (when-let [c (get-in colors [(:color (get default-teams color-key)) :color])]
      (str "rgba(" c ", " (or alpha 1) ")"))))

(rf/reg-sub :color-val-dark
  :<- [:colors]
  :<- [:default-teams]
  (fn [[colors default-teams] [_ color-key]]
    (let [color-key (if (keyword? color-key)
                      color-key
                      (keyword color-key))]
      (get-in colors [(:color (get default-teams color-key)) :dark]))))

(rf/reg-sub
  :rgb-color-dark
  :<- [:colors]
  :<- [:default-teams]
  (fn [[colors default-teams] [_ color-key alpha]]
    (when-let [c (get-in colors [(:color (get default-teams color-key)) :dark])]
      (str "rgba(" c ", " (or alpha 1) ")"))))

(rf/reg-sub :active-player-color-val
  :<- [:colors]
  :<- [:default-teams]
  :<- [:active-player]
  (fn [[colors default-teams active-player]]
    (get-in colors [(:color (get default-teams (keyword (:color active-player)))) :color])))

(rf/reg-sub
  :color-name
  :<- [:colors]
  :<- [:default-teams]
  (fn [[colors default-teams] [_ color-key]]
    (get-in colors [(:color (get default-teams color-key)) :name])))

(rf/reg-sub :app-category
  (fn [_ _] config/app-category))

(rf/reg-sub
  ::bec-rf/loading
  (fn [db _]
    (::bec-rf/loading db)))

(rf/reg-sub
  :client-loading
  (fn [db _]
    (:loading db)))

(rf/reg-sub
  :loading
  :<- [::bec-rf/loading]
  :<- [:client-loading]
  (fn [[bec-rf-loading client-loading] _]
    (merge bec-rf-loading client-loading)))

(rf/reg-sub :responses
  (fn [db path]
    (get-in db path)))

(rf/reg-sub :display-name ;; TODO: Have a reactive method on bcc (server) coordinate this instead; similar to customer-service :disabled?.
  (fn [db]
    (or (-> db :bec-core :shared-state :machines first second :information :display-name)
        (-> db :config :display-name))))

(rf/reg-sub :history
  (fn [db]
    (:history db)))

(rf/reg-sub :client-shared-state
  (fn [db [_ path]]
    (if path
      (get-in (-> db :bec-clj-common :views :shared) (if (keyword? path) [path] path))
      (-> db :bec-clj-common :views :shared))))

(rf/reg-sub :enable-more-teams? #(get-in % [:bec-clj-common :game :enable-more-teams?]))